import { combineReducers } from 'redux';
// Corresponding to CRUD: (no deletion yet)
import incidentDetails from './incidentDetails'; // Update
import incidents from './viewIncidents'; // Read
import initIncident from './initIncident';
import initTriggerForm from './initTriggerForm';

export default combineReducers({
  incidentDetails,
  incidents,
  initIncident,
  initTriggerForm,
});
